import React from "react";

export default function ProtectYourData() {
  return (
    <>
      <div className="tp-about-3-area  pb-110">
        <div className="container">
          <div className="row">
            <div className="">
              <div className="tp-about-3-title-box">
                <h3 className="tp-hero-3-title tp_reveal_anim text-center">
                  How We Protect Your Data
                </h3>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-5 col-md-4">
              <div className="text-center">
                <img src="assets/img/one/how_we_protect_your_data.png" alt="" />
              </div>
            </div>
            <div className="col-xl-7 col-lg-7  col-md-8">
              <div className="">
                <h4 className="text-yellow-new">Blockchain Security</h4>
                <p className="mb-30 tp_fade_bottom">
                  NFT ownership is secured through immutable blockchain records.
                </p>
                <h4 className="text-yellow-new">Encryption</h4>
                <p className="mb-45 tp_fade_bottom">
                  Sensitive user data (excluding blockchain transactions) is
                  encrypted to prevent unauthorized access.
                </p>
                <h4 className="text-yellow-new">Restricted Access</h4>
                <p className="mb-45 tp_fade_bottom">
                  Only authorized personnel can access limited user data for
                  operational purposes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
